import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[onlyNumbers]',
})
export class OnlyNumbersDirective {

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event']) onKeyPress($event) {
    if ([8, 9, 13, 27, 46].indexOf($event.keyCode) !== -1 ||
      ($event.keyCode == 65 && $event.ctrlKey === true) ||
      ($event.keyCode == 67 && $event.ctrlKey === true) ||
      ($event.keyCode == 86 && $event.ctrlKey === true) ||
      ($event.keyCode == 88 && $event.ctrlKey === true) ||
      ($event.keyCode >= 35 && $event.keyCode <= 39)) {
      return;
    }
    if ($event.key === ' ' || isNaN(Number($event.key)) || $event.shiftKey) {
      $event.preventDefault();
      $event.stopImmediatePropagation();
      $event.stopPropagation();
    }
  }
}
